/* ============================================================
   SCHEDULE TAB — PROTOTAIP DESIGN (dalam /workspace-v4)
   ============================================================
   ⛔ RUPA SAHAJA. Tiada Firestore/server/drag sebenar. Semua data contoh +
   useState tempatan. Tujuan: tunjuk macam mana Phone automation (Shopee)
   duduk dalam tab Schedule YANG SEDIA LIVE.

   Ikut live (agent recon 22 Okt): kalendar = jalur 3-hari dengan slot masa
   (KalendarMingguV39) + Cara post (Post now / Schedule / Draft) di Control
   Panel; "Schedule" live memang DIKUNCI bila bukan tab Schedule.

   Integrasi plan (keputusan user 22 Okt): bila Phone automation/Shopee ON →
   Shopee TAK boleh dijadualkan → "Schedule" DIKUNCI (corak SAMA macam live),
   kalendar jadi tak berkenaan (kelabu + overlay), tinggal Post now / Draft.
   Guna semula kelas sebenar .s-kal / .s-slot supaya rupa == live.

   UI = English (prototaip). Bila dibuka ke pelanggan: i18n + pil EN/BM dulu.
   ============================================================ */

import { useState } from 'react';
import { Plus, Video, Smartphone, Zap, FileText, CalendarDays, Lock, CircleCheck, CircleSlash, Cable, ChevronLeft, ChevronRight } from 'lucide-react';

import { Btn } from '../design/ui';
import '../design/tokens.css';
import '../design/ui.css';

// 3 hari contoh (ikut live: "Today · Aug 10", kiraan terisi/jumlah, slot masa).
const HARI = [
  {
    rel: 'Today', tarikh: 'Aug 23', terisi: 2, jumlah: 3,
    slot: [
      { jam: '08:00', kad: { nama: 'SIMMO Juicer 3-in-1 Blender', set: 1, status: 'done' } },
      { jam: '12:00', kad: { nama: 'Tudung Bawal Amani Premium', set: 2, status: 'draft' } },
      { jam: '20:00', kad: null },
    ],
  },
  {
    rel: 'Tomorrow', tarikh: 'Aug 24', terisi: 1, jumlah: 3,
    slot: [
      { jam: '09:00', kad: { nama: 'Barbie Lovito Quartz Watch', set: 1, status: null } },
      { jam: '13:00', kad: null },
      { jam: '21:00', kad: null },
    ],
  },
  {
    rel: 'Mon', tarikh: 'Aug 25', terisi: 0, jumlah: 2,
    slot: [
      { jam: '10:00', kad: null },
      { jam: '19:00', kad: null },
    ],
  },
];

const STATUS_KELAS = { done: 's-slot--siap', draft: 's-slot--draf', failed: 's-slot--gagal' };
const STATUS_TEKS = { done: 'Scheduled', draft: 'Draft', failed: 'Failed' };

function Slot({ jam, kad }) {
  if (!kad) {
    return (
      <div className="s-slot">
        <span className="s-slot__jam">{jam}</span>
        <span className="s-slot__ajak"><Plus size={12} strokeWidth={2} aria-hidden="true" /> Drop product here</span>
      </div>
    );
  }
  return (
    <div className={`s-slot s-slot--isi ${STATUS_KELAS[kad.status] || ''}`}>
      <div className="s-slot__kiri">
        <span className="s-slot__atas"><span className="s-slot__jam">{jam}</span></span>
        <button type="button" className="s-slot__nama">{kad.nama}</button>
        <span className="s-slot__set">
          {[1, 2, 3].map((n) => (
            <button key={n} type="button" className={`s-slot__pil ${kad.set === n ? 's-slot__pil--on' : ''}`}>S{n}</button>
          ))}
        </span>
        {kad.status && <span className="s-slot__status">{STATUS_TEKS[kad.status]}</span>}
      </div>
      <span className="s-slot__gambar" aria-hidden="true"><Video size={22} strokeWidth={1.6} /></span>
    </div>
  );
}

// Kad "pilih satu" ringkas (rupa sama PostTo / Cara post)
function PickCard({ on, locked, onClick, icon, label }) {
  return (
    <button type="button" role="radio" aria-checked={on} disabled={locked}
      onClick={() => { if (!locked && !on) onClick(); }}
      style={{
        position: 'relative', minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 4, padding: '10px 5px', font: 'inherit', textAlign: 'center', lineHeight: 1.2,
        cursor: locked ? 'not-allowed' : 'pointer', borderRadius: 'var(--s-r)',
        background: on ? 'var(--s-primary)' : 'var(--s-fill)',
        border: on ? '1px solid var(--s-primary)' : locked ? '1px dashed var(--s-line-strong)' : '1px solid var(--s-line-strong)',
        color: on ? 'var(--s-primary-ink)' : 'var(--s-ink-3)', opacity: locked ? 0.55 : 1,
      }}>
      {locked && <Lock size={12} style={{ position: 'absolute', top: 5, right: 6 }} aria-hidden="true" />}
      {icon}
      <span style={{ fontSize: 12, fontWeight: on ? 700 : 500 }}>{label}</span>
    </button>
  );
}

const SECT = { fontSize: 12, fontWeight: 600, color: 'var(--s-ink-2)', margin: '0 0 8px' };

export default function ScheduleTabPrototype() {
  const [phoneMode, setPhoneMode] = useState(false);
  const [connected, setConnected] = useState(false);
  // Cara post: non-phone boleh pilih; phone mode dikunci ke 'now'/'draft' sahaja.
  const [cara, setCara] = useState('schedule'); // 'now' | 'schedule' | 'draft'
  const caraPhone = cara === 'schedule' ? 'now' : cara; // schedule tak sah dalam phone mode

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 300px', gap: 18, alignItems: 'start' }}>
      {/* ── KIRI: kalendar 3-hari (rupa live) ── */}
      <div style={{ position: 'relative', minWidth: 0 }}>
        {/* bar navigasi — susunan diluluskan user 1 Nov: ‹ · Today · › + bulan & tahun besar.
            Style butang SAMA PERSIS v3.9 live (Btn ghost "Today" + s-iconbtn anak panah).
            Rupa sahaja (prototaip) — butang belum mengalih tarikh. */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <button type="button" className="s-iconbtn" aria-label="Previous">
              <ChevronLeft size={15} strokeWidth={2} />
            </button>
            <Btn variant="ghost" size="sm">Today</Btn>
            <button type="button" className="s-iconbtn" aria-label="Next">
              <ChevronRight size={15} strokeWidth={2} />
            </button>
            <span style={{ fontSize: 20, fontWeight: 600, color: 'var(--s-ink)', marginLeft: 4 }}>August 2026</span>
          </span>
          <span style={{ marginLeft: 'auto', color: 'var(--s-ink-2)', fontSize: 12.5 }}>
            Account: <b style={{ color: 'var(--s-ink)' }}>@sesaat.my</b>
          </span>
        </div>

        <div className="s-kal__grid" style={{ display: 'grid', gap: 6, gridTemplateColumns: 'repeat(3, minmax(0,1fr))', opacity: phoneMode ? 0.35 : 1, pointerEvents: phoneMode ? 'none' : 'auto', filter: phoneMode ? 'grayscale(1)' : 'none', transition: 'opacity .15s' }}>
          {HARI.map((h) => (
            <div key={h.tarikh} className="s-kal__lajur">
              <div className={`s-kal__hari ${h.rel === 'Today' ? 's-kal__hari--kini' : ''}`}>
                <span className="s-kal__tajukhari">{h.rel}</span>
                <span className="s-kal__tarikh">{h.tarikh}</span>
                <span className="s-kal__kira">{h.terisi}/{h.jumlah}</span>
              </div>
              <div className="s-kal__isi">
                {h.slot.map((s, i) => <Slot key={i} jam={s.jam} kad={s.kad} />)}
              </div>
            </div>
          ))}
        </div>

        {/* Overlay bila Phone/Shopee — kalendar tak berkenaan */}
        {phoneMode && (
          <div style={{
            position: 'absolute', inset: '38px 0 0', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 40,
          }}>
            <div style={{
              maxWidth: 360, textAlign: 'center', background: 'var(--s-card)', border: '1px solid var(--s-line-strong)',
              borderRadius: 'var(--s-r-lg)', padding: '22px 20px', boxShadow: '0 8px 30px rgba(0,0,0,.12)',
            }}>
              <CalendarDays size={28} style={{ color: 'var(--s-ink-3)' }} />
              <h3 style={{ fontSize: 15, fontWeight: 700, margin: '10px 0 6px' }}>Shopee can’t be scheduled</h3>
              <p style={{ fontSize: 12.5, color: 'var(--s-ink-2)', lineHeight: 1.5, margin: 0 }}>
                Posting to Shopee needs your phone connected, so there is no calendar slot. Use <b>Post now</b> (guided) or <b>Save as Draft</b> instead.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* ── KANAN: Control Panel (toggle + Post To + Cara post) ── */}
      <aside style={{ background: 'var(--s-card)', border: '1px solid var(--s-line)', borderRadius: 'var(--s-r-lg)', padding: 14, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <p className="s-cardhead__t" style={{ margin: 0 }}>Control Panel</p>

        {/* Toggle Phone automation */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, border: '1px solid var(--s-line-strong)', borderRadius: 'var(--s-r)', padding: '10px 12px', background: phoneMode ? 'var(--s-brand-soft)' : 'transparent' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
            <Smartphone size={17} style={{ color: phoneMode ? 'var(--s-brand)' : 'var(--s-ink-2)', flex: '0 0 auto' }} />
            <span style={{ fontSize: 13, fontWeight: 600 }}>Phone automation</span>
          </span>
          <button type="button" role="switch" aria-checked={phoneMode} onClick={() => setPhoneMode((v) => !v)}
            style={{ flex: '0 0 auto', width: 42, height: 24, borderRadius: 999, border: 'none', cursor: 'pointer', padding: 2, background: phoneMode ? 'var(--s-brand)' : 'var(--s-line-strong)', display: 'flex', justifyContent: phoneMode ? 'flex-end' : 'flex-start', alignItems: 'center' }}>
            <span style={{ width: 20, height: 20, borderRadius: 999, background: '#fff', display: 'block' }} />
          </button>
        </div>

        {phoneMode && (
          <button type="button" onClick={() => setConnected((v) => !v)}
            style={{ display: 'flex', alignItems: 'center', gap: 8, font: 'inherit', textAlign: 'left', cursor: 'pointer', border: `1px solid ${connected ? 'var(--s-ok)' : 'var(--s-warn)'}`, background: connected ? 'var(--s-ok-soft)' : 'var(--s-warn-soft)', color: connected ? 'var(--s-ok)' : 'var(--s-warn)', borderRadius: 'var(--s-r)', padding: '8px 10px', fontSize: 12.5 }}>
            {connected ? <CircleCheck size={15} /> : <CircleSlash size={15} />}
            <b>Phone: {connected ? 'Connected' : 'Not connected'}</b>
            <Cable size={14} style={{ marginLeft: 'auto', opacity: .6 }} />
          </button>
        )}

        {/* Post To */}
        <div>
          <p style={SECT}>Post To</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 8 }}>
            {!phoneMode ? (
              <>
                <PickCard on label="Facebook Reels" icon={<Video size={18} />} />
                <PickCard locked label="TikTok" icon={<Video size={18} />} />
              </>
            ) : (
              <>
                <PickCard on label="Shopee Video" icon={<Video size={18} />} />
                <PickCard locked label="More apps" icon={<Plus size={18} />} />
              </>
            )}
          </div>
        </div>

        {/* Cara post — Schedule DIKUNCI dalam phone mode (corak SAMA live) */}
        <div>
          <p style={SECT}>{phoneMode ? 'How to post' : 'Cara post'}</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 8 }}>
            <PickCard on={(phoneMode ? caraPhone : cara) === 'now'} onClick={() => setCara('now')} icon={<Zap size={18} />} label="Post now" />
            <PickCard
              on={!phoneMode && cara === 'schedule'}
              locked={phoneMode}
              onClick={() => setCara('schedule')}
              icon={<CalendarDays size={18} />}
              label="Schedule"
            />
            <PickCard on={(phoneMode ? caraPhone : cara) === 'draft'} onClick={() => setCara('draft')} icon={<FileText size={18} />} label="Draft" />
          </div>
          <p style={{ fontSize: 11, color: 'var(--s-ink-2)', margin: '8px 0 0', lineHeight: 1.5 }}>
            {phoneMode
              ? 'Shopee can’t be scheduled — the phone must be connected. Post now (guided, you tap Publish) or save a Draft.'
              : 'Schedule is active — the calendar slots on the left set the time.'}
          </p>
        </div>
      </aside>
    </div>
  );
}
